import React from 'react';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { Check, X } from 'lucide-react';

import { Flex } from 'src/components/flex';
import type { IReplySuggestion } from 'src/services/api';

import styles from './ReplySuggestions.module.css';

type Props = {
    suggestions: IReplySuggestion[];
    onSelect: (suggestion: IReplySuggestion) => void;
    onDismiss: (suggestion: IReplySuggestion) => void;
};

/** Single-focus nudge offering grounded replies to the lead's latest question. */
export const ReplySuggestions = ({ suggestions, onSelect, onDismiss }: Props) => {
    if (suggestions.length === 0) {
        return null;
    }

    return (
        <div className={styles.bar} data-testid="reply-suggestions">
            <Typography variant="subtitle2" className={styles.heading}>
                Suggested reply:
            </Typography>
            <Flex columnGap={1} flexWrap="wrap" alignItems="center">
                {suggestions.map((s) => (
                    <div
                        key={s.id}
                        className={styles.chip}
                        data-testid={`reply-suggestion-${s.id}`}
                    >
                        <Typography variant="body2" component="span">
                            {s.content}
                        </Typography>
                        <IconButton
                            size="small"
                            color="primary"
                            data-testid={`accept-reply-${s.id}`}
                            onClick={() => onSelect(s)}
                        >
                            <Check size={18} />
                        </IconButton>
                        <IconButton
                            size="small"
                            color="error"
                            className={styles.dismissButton}
                            data-testid={`dismiss-reply-${s.id}`}
                            onClick={() => onDismiss(s)}
                        >
                            <X size={18} />
                        </IconButton>
                    </div>
                ))}
            </Flex>
        </div>
    );
};

export default ReplySuggestions;
